import { useMutation } from "@tanstack/react-query"
import { websiteAuthService } from "@/api/websiteAuthService"
import { toast } from "sonner"
import { useNavigate } from "react-router-dom"

export const useRegister = () => {
  const navigate = useNavigate()

  return useMutation({
    mutationFn: websiteAuthService.register,
    onSuccess: (_response, variables) => {
      localStorage.removeItem("website_token")
      localStorage.removeItem("customer")
      toast.success("Account created. Please verify your email.")
      navigate(`/verify-email?email=${encodeURIComponent(variables.email)}`)
    },
    onError: (error: any) => {
      localStorage.removeItem("website_token")
      localStorage.removeItem("customer")

      const serverError = error
      const firstError = Object.values(serverError?.error || {}).find(
        Array.isArray
      ) as string[] | undefined
      toast.error(
        firstError?.[0] || serverError?.message || "Failed to register"
      )
    },
  })
}
